import {create, StateCreator} from 'zustand';
import {initialState, DraftGuessStore} from './types';
import actions from './actions';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const draftGuessStore: StateCreator<
  DraftGuessStore,
  [['zustand/devtools', never], ['zustand/immer', never]] // https://zustand.docs.pmnd.rs/guides/advanced-typescript#middlewares-and-their-mutators-reference
> = (set, get) => ({
  ...initialState,
  ...actions(set, get)
});

export const useDraftGuessStore = create<DraftGuessStore>()(
  devtools(immer(draftGuessStore), {name: 'draft-guess'})
);

export * from './types';
export default useDraftGuessStore;
